import React, { useRef } from 'react';

// Time stepper with -/+ buttons (press-and-hold repeats) around a native
// time input. Value is "HH:MM" (empty string = unset). step in minutes.
function TimeStepper({ label, value, onChange, step = 5, disabled = false }) {
  const holdTimer = useRef(null);

  const bump = (dir) => {
    const [h, m] = (value || '08:00').split(':').map(Number);
    let total = h * 60 + m + dir * step;
    total = ((total % 1440) + 1440) % 1440; // wrap around midnight
    const pad = (n) => String(n).padStart(2, '0');
    onChange(`${pad(Math.floor(total / 60))}:${pad(total % 60)}`);
  };

  const startHold = (dir) => {
    bump(dir);
    let delay = 400;
    const repeat = () => {
      bump(dir);
      delay = Math.max(80, delay - 60);
      holdTimer.current = setTimeout(repeat, delay);
    };
    holdTimer.current = setTimeout(repeat, delay);
  };

  const endHold = () => {
    if (holdTimer.current) clearTimeout(holdTimer.current);
    holdTimer.current = null;
  };

  const btn =
    'flex h-11 w-11 items-center justify-center rounded-xl bg-gray-100 text-lg font-bold text-gray-700 transition-transform active:scale-95 disabled:opacity-40';

  return (
    <div className="flex items-center gap-2">
      {label && <span className="w-14 shrink-0 text-sm text-gray-500">{label}</span>}
      <button
        type="button"
        className={btn}
        disabled={disabled}
        onPointerDown={() => startHold(-1)}
        onPointerUp={endHold}
        onPointerLeave={endHold}
      >
        −
      </button>
      <input
        type="time"
        value={value || ''}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        className="min-h-[44px] flex-1 rounded-xl border border-gray-200 px-2 text-center text-sm disabled:bg-gray-50"
      />
      <button
        type="button"
        className={btn}
        disabled={disabled}
        onPointerDown={() => startHold(1)}
        onPointerUp={endHold}
        onPointerLeave={endHold}
      >
        +
      </button>
    </div>
  );
}

export default TimeStepper;
